import React, { useState, useEffect  } from 'react';
import PropTypes from 'prop-types';
import { getAllManufacturerForSchool } from '../../../api/districtproductsapi';
import { getProduct } from '../../../api/productapi';
import { AdminModal } from '../../../components/admin/admin-modal';


export default function SchoolProducts({ districtId, schoolId, schoolProducts, setSchoolProducts, schoolProductOptions, setSchoolProductOptions }) {
    const [manufacturers, setManufacturers] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedAllProductOptions, setSelectedAllProductOptions] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [deselectedOptions, setDeselectedOptions] = useState([]);
    const [viewProduct, setViewProduct] = useState({});
    const [showModal, setShowModal] = useState(false);  
    const [schoolProductOptionItems, setSchoolProductOptionItems] = useState([]);     



    useEffect(() => { 
        getAllManufacturerForSchool(districtId)
            .then((response) => {
                setManufacturers(response.data.data);        
            })
            .catch((err) => {
                console.error('Error fetching manufacturers:', err);
                setError(err);
            })
            .finally(() => {
                setLoading(false);
            });


    }, [districtId]);

    useEffect(() => {
        const productIds = schoolProducts.map(item => item.productId);
        setSelectedProducts(productIds);       
    }, [schoolProducts]);

    useEffect(() => {
        const productItemIds = schoolProductOptions.map(item => item.productOptionItemId);
        setSelectedAllProductOptions(productItemIds);
    }, [schoolProductOptions]);


    const handleSelection = (event, bulkUpdates = []) => { 
        if (bulkUpdates.length) {
            const uniqueProductIds = [...new Set(bulkUpdates)];
            const schoolProductUpdate = uniqueProductIds.map(productId => ({
                schoolId,
                productId,
                hasAllOptions: true,
            }));
            setSchoolProducts(schoolProductUpdate);
            setSelectedProducts(uniqueProductIds);
        } else {
            const productId = parseInt(event.target.id);
            if (selectedProducts.includes(productId)) {         
                setSchoolProducts((prev) => prev.filter((item) => item.productId !== productId));
                setSelectedProducts((prev) => prev.filter((id) => id !== productId));
            } else {       
                setSchoolProducts((prev) => [...prev, { schoolId, productId, hasAllOptions: true }]);
                setSelectedProducts((prev) => [...prev, productId]);
            }
        }
    };

    const handleBulkSelection = (productLineId, products, shouldSelect) => {
        if (shouldSelect) {
            const newSelections = products.map((product) => product.id);
            //select product options where no options for a given product were previously selected
            var productLine = [...manufacturers.map(a => a.productLines).reduce((a, b) => [...a, ...b])].filter(a => a.id == productLineId)[0];
            var optionItems = productLine.products ? productLine.products.filter(a => (a.optionItems && a.optionItems.length > 0 &&
                a.optionItems.filter(b => selectedAllProductOptions.filter(c => c == b).length > 0).length == 0)
                || !a.optionItems || a.optionItems.length == 0
            ).map(a => a.optionItems) : [];
            if (optionItems.length > 0) {
                var options = [...optionItems.reduce((a, b) => [...a, ...b])];
                handleBulkOptionsSelection(options, true);
            }
            //select products
            handleSelection(null, [...selectedProducts, ...newSelections]);
        } else {     

            const idsToRemove = products.map((product) => product.id);
            const updatedSelections = selectedProducts.filter((id) => !idsToRemove.includes(id)); 

            setSchoolProducts((prev) => prev.filter((item) => !idsToRemove.includes(item.productId)));            
            setSelectedProducts(updatedSelections);

            const productLineIds = manufacturers.flatMap(m => m.productLines).find(pl => pl.id === productLineId);
            const removeItemIds = productLineIds?.products.map(a => a.optionItems).flat();

            if (removeItemIds.length > 0) {
                handleBulkOptionsSelection(removeItemIds, false);
            }          
        }
    };

    const handleBulkOptionsSelection = (itemIds, shouldSelect) => {
    
        setSchoolProductOptions((prev) => prev.filter((item) => !itemIds.includes(item.productOptionItemId)));
        setSelectedProductOptions(selectedProductOptions.filter((id) => !itemIds.includes(id)));
        setSelectedAllProductOptions((prev) =>
            prev.filter((id) => itemIds.filter(a => a == id).length == 0)
        );
        if (shouldSelect) {
            const schoolProductOptionsUpdate = itemIds.map(itemId => ({
                productOptionItemId: itemId,
                productOptionId: 0,
                productId: 0,
                schoolId: schoolId
            }));
            setSchoolProductOptions((prev) => [...prev, ...schoolProductOptionsUpdate]);
            setSelectedProductOptions((prev) => [...prev, ...itemIds]);
            setSelectedAllProductOptions((prev) => [...prev, ...itemIds]);
            setDeselectedOptions((prev) => prev.filter((id) => !itemIds.includes(id)));
        } else {
            setDeselectedOptions((prev) => [...new Set([...prev, ...itemIds])]);
        }
    };

    const fetchProductDetails = (productId) => {
        const updateSchoolProductOptionItems = manufacturers.flatMap(m => m.productLines || []).flatMap(pl => pl.products || []).find(p => p.id === productId)?.optionItems;
        setSchoolProductOptionItems(updateSchoolProductOptionItems);

        getProduct(productId)
            .then((response) => {
                let product = response.data.data;      
                setViewProduct(product);
                var options = product.options ? product.options.filter(a => a.items != null && a.items.length > 0).map(a => a.items) : [];
                var optionItems = [];
                options.forEach(a => optionItems.push(...a));
                var selectedItems = selectedAllProductOptions.filter(a => optionItems.filter(b => b.id == a).length > 0);
                setSelectedProductOptions(selectedItems);
                if (selectedProducts.filter(a => a == productId).length == 0) {     
                    setSchoolProducts((prev) => [...prev, { schoolId, productId, hasAllOptions: true }]);
                    setSelectedProducts((prev) => [...prev, productId]);
                }
                setShowModal(options && updateSchoolProductOptionItems.length > 0 && options.length > 0);

            })
            .catch((err) => {
                console.error('Error fetching district products:', err);
                setError(err);
            });
    };

    const handleProductOptionsSelection = (event, productOptionId, productId) => { 
        const itemId = parseInt(event.target.id.replace('optionitem', ''));
        if (selectedProductOptions.includes(itemId)) {
            setSchoolProductOptions((prev) =>
                prev.filter((item) => item.productOptionItemId !== itemId)
            );

            setSelectedProductOptions((prev) =>
                prev.filter((id) => id !== itemId)
            );
            setSelectedAllProductOptions((prev) =>
                prev.filter((id) => id !== itemId)
            );
            setDeselectedOptions((prev) => [...prev, itemId]);
        } else {
            setSchoolProductOptions((prev) => [...prev, { productOptionItemId: itemId, productOptionId: productOptionId, productId: productId, schoolId: schoolId }]);
            setSelectedProductOptions((prev) => [...prev, itemId]);
            setSelectedAllProductOptions((prev) => [...prev, itemId]);
            setDeselectedOptions((prev) => prev.filter((id) => id !== itemId));
        }
    };

    const handleViewedProductSave = () => {
        //addProductOptionItems(districtId, selectedProductOptions.filter(a => a != null));
        if (deselectedOptions && deselectedOptions?.length > 0) {
            //removeProductOptionItems(districtId, deselectedOptions);
            setDeselectedOptions([]);
        }
        setShowModal(false);
    };

    const onClose = () => {
        setShowModal(false);
    };


    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    return (
        <div>
            <h2 className="admin-round-swatch-title-text">Products</h2>

            <div className="admin-tab-content">
                <div>
                {manufacturers && manufacturers.map(manufacturer => (
                    <div key={manufacturer.id} className="admin-product-checkbox-section">
                        <div className="manufacturer-section-header">
                            <h5 className="manufacturer-section-headline">{manufacturer.name}</h5>
                        </div>
                        <div className="admin-column-wrap allow-wrapping">
                            {manufacturer.productLines.filter(a => a.products.length > 0).map((productLine) => {
                                var hasAllProducts = productLine.products.filter(a => selectedProducts.filter(b => a.id == b).length > 0).length == productLine.products.length;
                                return (
                                    <div key={productLine.id} className="admin-column">
                                        <p className="admin-section-small-headline">
                                            {productLine.name}
                                        </p>

                                        <label
                                            className="admin-inline-label"
                                            htmlFor={`bulk-${productLine.id}`}
                                        >
                                            <input
                                                className="admin-inline-checkbox"
                                                id={`bulk-${productLine.id}`}
                                                type="checkbox"
                                                checked={hasAllProducts}
                                                onChange={() => {                                                 
                                                    handleBulkSelection(
                                                        productLine.id,
                                                        productLine.products,
                                                        !hasAllProducts
                                                    );
                                                }}
                                            />
                                            {/*<span className="checkmark"></span>*/}
                                            <span className="admin-inline-label-text">
                                                {hasAllProducts
                                                    ? 'Clear All'
                                                    : 'Select All'}
                                            </span>
                                        </label>

                                        <div
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                border: '0.50px #D9D9D9 solid',
                                            }}
                                        ></div>

                                        {productLine.products?.map((product) => {
                                            const productOptionItems = product.optionItems.length;
                                            const selectedOptionItems = product.optionItems && product.optionItems.length > 0 ? selectedAllProductOptions.filter(a => product.optionItems.filter(b => b == a).length > 0).length : 0;
                                            let selected = selectedProducts.filter(a => a == product.id).length > 0;
                                            if ((!selected && selectedOptionItems == 0) && productOptionItems > 0) {
                                                selected = false;
                                            }

                                            return (
                                                <span className={'admin-inline-label' + (productOptionItems > selectedOptionItems && selectedOptionItems > 0 ? ' ind-dash' : '')} key={product.id}>
                                                    <input
                                                        className="admin-inline-checkbox"
                                                        id={product.id}
                                                        type="checkbox"
                                                        checked={selected}
                                                        value={product.name}
                                                        onChange={handleSelection}
                                                        onClick={(e) => e.stopPropagation()}
                                                    />
                                                    {/*<span className="checkmark"></span>*/}
                                                    <span className="admin-inline-label-text product-label"
                                                        onClick={() => fetchProductDetails(product.id)}
                                                    >
                                                        {product.productTitle}
                                                        {productOptionItems > 0 && selected ?
                                                            <span className="total-items">({selectedOptionItems}/{productOptionItems})</span>
                                                            : <></>
                                                        }
                                                    </span>
                                                </span>
                                            )
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
                </div>
            </div>
            <AdminModal
                show={showModal}
                onClose={onClose}
                onSave={handleViewedProductSave}
                modalTitle={viewProduct.details ? viewProduct.details.name : ''}
                adminModalClass="large grow"
            >
                {viewProduct &&
                    viewProduct.options &&
                    viewProduct.options.length === 0 ? (
                    <div className="admin-modal-row full">
                        <div className="admin-modal-cell full">
                            <p>No options selected.</p>
                        </div>
                    </div>
                ) : (
                    <div className="admin-modal-row full">
                        <div className="admin-modal-cell full">
                            <div className="admin-column-wrap allow-wrapping">
                                {viewProduct &&
                                    viewProduct.options &&
                                    viewProduct.options.filter(a => a.items && a.items.length > 0 && a.items.some(i => schoolProductOptionItems.includes(i.id))).map((option) => {
                                        const selectedAll = selectedAllProductOptions.filter(a => option.items.filter(b => b.id == a).length > 0).length == option.items.filter(i => schoolProductOptionItems.includes(i.id)).length;
                                        return (
                                            <div key={option.id} className="admin-column">
                                                <p className="admin-section-small-headline">
                                                    {option.title}
                                                </p>
                                                <label
                                                    className="admin-inline-label"
                                                    htmlFor={`bulk-option-${option.id}`}
                                                >
                                                    <input
                                                        className="admin-inline-checkbox"
                                                        id={`bulk-option-${option.id}`}
                                                        type="checkbox"
                                                        checked={selectedAll}
                                                        onChange={() =>
                                                            handleBulkOptionsSelection(
                                                                option.items.filter(i => schoolProductOptionItems.includes(i.id)).map((item) => item.id),
                                                                !selectedAll
                                                            )
                                                        }
                                                    />
                                                    <span className="admin-inline-label-text">
                                                        {selectedAll
                                                            ? 'Clear All'
                                                            : 'Select All'}
                                                    </span>
                                                </label>
                                                <div
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        border: '0.50px #D9D9D9 solid',
                                                    }}
                                                ></div>
                                                {option.items &&
                                                    option.items.filter(i => schoolProductOptionItems.includes(i.id)).map((item) => (

                                                        <label
                                                            className="admin-inline-label"
                                                            htmlFor={'optionitem' + item.id}
                                                            key={'optionitem' + item.id}
                                                        >
                                                            <input
                                                                className="admin-inline-checkbox"
                                                                id={'optionitem' + item.id}
                                                                type="checkbox"
                                                                value={item.name}
                                                                checked={selectedAllProductOptions.includes(item.id)}
                                                                onChange={(e) => handleProductOptionsSelection(e, option.id, viewProduct.id)}
                                                            />
                                                            <span className="admin-inline-label-text">
                                                                {option.type == 2 && item.color ? item.color.name : item.title}
                                                            </span>
                                                        </label>
                                                    ))}
                                            </div>
                                        )
                                    })}
                            </div>
                        </div>
                    </div>
                )}
            </AdminModal>
        </div>
    );

}

SchoolProducts.propTypes = {
    districtId: PropTypes.string,    
    schoolId: PropTypes.number, 
    schoolProducts: PropTypes.array,
    setSchoolProducts: PropTypes.func,
    schoolProductOptions: PropTypes.array,
    setSchoolProductOptions: PropTypes.func
};